import { Text } from '@chakra-ui/react';
import { formatDueDateWithStatus } from '../utils/dateUtils';

/**
 * Reusable component for displaying due dates with status-aware formatting
 * @param {string|Date} dueDate - The due date
 * @param {string} ticketStatus - The ticket status
 * @returns {JSX.Element} Formatted due date with appropriate styling
 */
const DueDateDisplay = ({ dueDate, ticketStatus }) => {
  if (!dueDate) return '-';

  const result = formatDueDateWithStatus(dueDate, ticketStatus);

  // If result is an object, it's a special case (today, tomorrow, overdue)
  if (typeof result === 'object') {
    switch (result.type) {
      case 'today':
        return <Text color="red.500" fontWeight="bold">Today</Text>;
      case 'tomorrow':
        return <Text color="orange.500" fontWeight="bold">Tomorrow</Text>;
      case 'overdue':
        return <Text color="red.500" fontWeight="bold">{result.label}</Text>;
      default:
        return result;
    }
  }

  return result;
};

export default DueDateDisplay;
